import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import RatingDisplayOnly from '../../components/RatingDisplayOnly';
import Segment from '../../components/Segment';
import Icon from '../../components/Icon';
import Button from '../../components/Button';
import Container from '../../components/Container';
import Loader from '../../components/Loader';

import '../RepVisitsRatingsMemberDetails/styles.css';
import messages from '../RepVisitsRatingsOverviewPage/messages';

const getUserFullInstitutionTitle = (u) => ` ${u.field_user_institution_title}`;

class RatingDetailsList extends React.PureComponent {
  static propTypes = {
    node: PropTypes.object,
    loadMore: PropTypes.func.isRequired,
    viewer: PropTypes.shape({
      enabledFeatures: PropTypes.array,
    }),
  };

  state = { loading: false };

  loadMore = () => {
    this.setState({ loading: true });
    this.props.loadMore('node.ratingsDetails').then(() => this.setState({ loading: false }));
  };

  render() {
    const { viewer, node } = this.props;
    const isCommunityServerlessOn = viewer?.enabledFeatures?.includes('COMMUNITYSERVERLESS');
    const ratingDetails = node.ratingsDetails.edges.map((group) => group.node);
    return (
      <div>
        {ratingDetails.map(({ stars, id, isAnonymous, reviewer, comment, feedback }) => {
          const iconProps = stars === 5 ?
            { 'name': 'thumbs up', 'aria-label': 'Thumbs Up' } :
            { 'name': 'thumbs outline down', 'flipped': 'horizontally', 'aria-label': 'Thumbs Down' };
          return (
            <Segment vertical data-cy="repvisits-user-rating-segment" className="rating-segment" key={id}>
              <RatingDisplayOnly rating={stars} maxRating={5} />{' '}
              {isAnonymous ?
                <FormattedMessage {...messages.anonymous} /> : (
                  <React.Fragment>
                    {!reviewer ?
                      <FormattedMessage {...messages.unknownUser} /> : (
                        <span>{
                          isCommunityServerlessOn ? (
                            <Link data-cy="repvisits-feedback-comment-username" to={`/counselorcommunity/search/people/${reviewer.communityId}`}>
                              {`${reviewer.name} `}
                            </Link>
                          ) : (
                            <Link data-cy="repvisits-feedback-comment-username" to={`/counselor-community/profile/${reviewer.communityId}`}>
                              {`${reviewer.name} `}
                            </Link>
                          )
                        }
                          <FormattedMessage {...messages.at} />
                          {
                            isCommunityServerlessOn ? (
                              <Link
                                data-cy="repvisits-feedback-comment-college"
                                to={`/counselorcommunity/search/institutions/highschools/${reviewer.field_user_institution_uuid}`}
                              >
                                {getUserFullInstitutionTitle(reviewer)}
                              </Link>
                            ) : (
                              <Link
                                data-cy="repvisits-feedback-comment-college"
                                to={`/counselor-community/institution/${reviewer.field_user_institution}`}
                              >
                                {getUserFullInstitutionTitle(reviewer)}
                              </Link>
                            )
                          }
                        &nbsp;({`${reviewer.field_user_institution_city}, ${reviewer.field_user_institution_state}`})
                        </span>
                      )}
                  </React.Fragment>
                )}
              &nbsp;<FormattedMessage {...messages.submittedFeedback} />
              <strong>
                <FormattedMessage
                  {...messages.starsCount}
                  values={{
                    stars,
                  }}
                />
              </strong>
              {comment && (
              <div data-cy="repvisits-feedback-user-comment" styleName="rating-comment">
                &quot;{comment}&quot;
              </div>
              )}
              <div styleName="rating-feedback">
                {feedback.map((feedbackItem) => (
                  <span data-cy="repvisits-feedback-user-improvement-bubble" styleName="improvement-area-label" key={feedbackItem}>
                    <FormattedMessage {...messages[feedbackItem.toLowerCase()]} />
                    <Icon disabled {...iconProps} />
                  </span>
                ))}
              </div>
            </Segment>
          );
        })}
        {get(this.props.node, 'ratingsDetails.pageInfo.hasNextPage') && (
        <Container textAlign="center">
          <Loader inline active={this.state.loading} />
          <Button className="asLinkBtn" styleName="asLinkBtn" onClick={this.loadMore}>
            <FormattedMessage {...messages.loadMore} />
          </Button>
        </Container>
        )}
      </div>
    );
  }
}

export default RatingDetailsList;
